import React, { useEffect, useMemo, useState } from "react";
import { getInitials, normalizeUser, resolveAssetUrl } from "../../utils/user.js";
import { useTheme } from "../../context/ThemeContext.jsx";
const SIZE_CLASSES = {
  xs: "h-4 w-4 text-[9px]",
  sm: "h-6 w-6 text-xs",
  md: "h-8 w-8 text-sm",
  lg: "h-10 w-10 text-base",
  xl: "h-12 w-12 text-lg"
};
export default function Avatar({
  user,
  src,
  size = "md",
  className = ""
}) {
    const normalized = useMemo(() => normalizeUser(user), [user]);
  const name = normalized?.name || "";
  const initials = getInitials(name);
  const resolvedSrc = useMemo(() => resolveAssetUrl(src || normalized?.avatarUrl), [src, normalized?.avatarUrl]);
  const [broken, setBroken] = useState(false);
  useEffect(() => {
    setBroken(false);
  }, [resolvedSrc]);
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const alt = name ? `Avatar von ${name}` : "Avatar";
  const showImage = Boolean(resolvedSrc) && !broken;
  return <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ring-1 ${"bg-blue-600/20 text-blue-100 ring-white/10"} ${sizeClass} ${className}`} aria-label={alt}>
      {showImage ? <img src={resolvedSrc} alt={alt} className="h-full w-full object-cover" loading="lazy" decoding="async" onError={() => setBroken(true)} draggable={false} /> : <span className="font-semibold leading-none">{initials || "?"}</span>}
    </span>;
}